/** API route map: URLS.Controller.ClientEmployees */
export const ClientEmployees = {
      Name: 'ClientEmployees/',
      GetEmployeesCount: 'get-employees-count',
      GetNewEmployeesPaginated: 'get-new-employees-paginated',
      GetPendingEmployeesPaginated: 'get-pending-employees-paginated',
      GetApprovedEmployeesPaginated: 'get-approved-employees-paginated',
      SendHirePacket: 'send-hire-packet',
      SendHirePacketManual: 'send-hire-packet-manual',
      SendHirePacketBulk: 'send-hire-packet-bulk',
      ResendHirePacket: 'resend-hire-packet',
      ReSendHirePacketBulk: 'resend-hire-packet-bulk',
      Approve: 'approve',
      GetSentHirePacket: 'get-sent-hire-packet',
      GetSentHirePacketView: 'get-sent-hire-packet-view',
      SaveQuestionnaireAsDraft: 'save-questionnaire-as-draft',
      SavePersonalInformationAsDraft: 'save-personal-information-as-draft',
      SaveEmergencyContactAsDraft: 'save-emergency-contact-as-draft',
      SaveJobInformationAsDraft: 'save-job-information-as-draft',
      UploadSubmittedForm: 'upload-submitted-form',
      SubmitNHPForm: 'submit-nhp-form',
      // EN-29808 - Tasks step (endpoint already existed on the API, just unwired here).
      SaveTaskStatusAsDraft: 'save-task-status-as-draft',
      ChangeEmployeePosition: 'change-employee-position',
      SearchEmployeePosition: 'get-all-positions',
      GetAllEmployeePositions: 'get-position-history',
      GetW4Form: 'get-w4-form',
      UpdateEmployeeW4: 'update-w4',
      EmployeePortalSignup: 'employee-portal-signup',
      // EN-29808 — added for the employee-facing Employee Onboarding / Submit New Hire Packet
      // feature, ported from Enwage-PEO-Frontend (same endpoint name/value).
      GetEmployeeOnboardingStatus: 'get-employee-onboarding-status',
      UploadEmployeeSignature: 'upload-employee-signature',
      DeleteEmployeeSignature: 'delete-employee-signature',
};
